import { Context, createContext } from 'react';

const SiteSettingsContext: Context<any> = createContext(undefined);

export default SiteSettingsContext;
